import { useHistory, useParams } from "react-router-dom";
import { TODPrivacyPolicy } from "../Apps/TruthOrDare/PrivacyPolicy";
import s from "./policy.module.scss";

const Policies: any = {
  "truth-or-dare": <TODPrivacyPolicy />,
};

export const PrivacyPolicies = () => {
  const { policy }: any = useParams();
  const history = useHistory();
  if (Policies[policy]) return <Policy policy={policy} />;
  history.push("/");
  return <p>Loading</p>;
};

const Policy = ({ policy }: any) => {
  return (
    <div className={s.policy}>
      <div className={s.bgImg}></div>
      <div className={s.content}>{Policies[policy]}</div>
    </div>
  );
};
